/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabasePage
 */
export interface DatabasePage {
    /**
     * 
     * @type {boolean}
     * @memberof DatabasePage
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabasePage
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePage
     */
    ctaCaption?: string;
}

/**
 * Check if a given object implements the DatabasePage interface.
 */
export function instanceOfDatabasePage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabasePageFromJSON(json: any): DatabasePage {
    return DatabasePageFromJSONTyped(json, false);
}

export function DatabasePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'ctaCaption': !exists(json, 'ctaCaption') ? undefined : json['ctaCaption'],
    };
}

export function DatabasePageToJSON(value?: DatabasePage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'content': value.content,
        'ctaCaption': value.ctaCaption,
    };
}

